<div class="onboarding-checklist-page" [class.journey-active]="journeyEnabled" [class.aj-active]="journeyEnabled">
  <!-- Header -->
  <header class="onboarding-header" [class.journey-header]="journeyEnabled" [class.aj-header]="journeyEnabled">
    <div class="header-content">
      <div class="journey-brand" *ngIf="journeyEnabled; else classicLogo">
        <img src="https://supersee.io/wp-content/uploads/2025/02/Supersee_Logo-1.webp" alt="SuperSee"
          class="header-logo">
        <span class="journey-brand-mark" *ngIf="currentStepId !== 'goal_selected'">{{ journeySectionLabel }}</span>
      </div>
      <ng-template #classicLogo>
        <img src="https://supersee.io/wp-content/uploads/2025/02/Supersee_Logo-1.webp" alt="SuperSee Logo"
          class="header-logo">
      </ng-template>

      <div class="progress-indicator" *ngIf="!journeyEnabled">
        <span class="progress-text">Step {{ currentStepNumber }} of {{ totalSteps }}</span>
      </div>
      <div class="journey-chapter" *ngIf="journeyEnabled" aria-label="Setup progress">
        <ol class="journey-chapter-dots journey-chapter-steps">
          <li *ngFor="let ch of journeyVisibleChapters; let i = index"
            [class.is-done]="i < journeyChapterHighlightIndex"
            [class.is-current]="i === journeyChapterHighlightIndex"
            [attr.aria-current]="i === journeyChapterHighlightIndex ? 'step' : null">
            <span class="journey-chapter-num" aria-hidden="true">{{ i + 1 }}</span>
            <span class="journey-chapter-name">{{ ch.label }}</span>
          </li>
        </ol>
      </div>

      <div class="header-actions">
        <button type="button" class="header-btn journey-restart-btn"
          *ngIf="journeyEnabled && showRestartJourney && currentStepId !== 'goal_selected'"
          (click)="restartActivationJourney()" title="Start the setup journey from the beginning">
          <span class="material-symbols-outlined">restart_alt</span> Restart journey
        </button>
        <button type="button" class="header-btn journey-exit-btn" *ngIf="showExitSetup" (click)="exitSetup()">
          <span class="material-symbols-outlined">arrow_back</span> Exit setup
        </button>
        <button class="header-btn help-btn" (click)="contactSupport()">
          <span class="material-symbols-outlined">chat_bubble</span> Need help?
        </button>
        <button class="header-btn logout-btn" *ngIf="currentStepId !== 'goal_selected'" (click)="logoutUser()">
          <span class="material-symbols-outlined">logout</span> Logout
        </button>
      </div>
    </div>
  </header>

  <!-- Main Content -->
  <main class="onboarding-main" [class.journey-main]="journeyEnabled">
    <!-- ===================== ACTIVATION JOURNEY ===================== -->
    <ng-container *ngIf="journeyEnabled">

      <!-- A1 Ready — workspace setup (mockup composition) -->
      <div class="step-content journey-stage journey-ready journey-ready--workspace" *ngIf="currentStepId === 'goal_selected'">
        <div class="journey-ready-stage">
          <p class="journey-ready-verified">
            <mat-icon aria-hidden="true">check_circle</mat-icon>
            <span>{{ guideCopy.readyEmailKicker }}.</span>
          </p>

          <div class="journey-ready-hero">
            <p class="journey-ready-step-label">{{ guideCopy.readyStepLabel }}</p>
            <h1 class="journey-display">{{ guideCopy.readyHeadline }}</h1>
            <p class="journey-empathy">{{ guideCopy.readyDecisionBody }}</p>
          </div>

          <section class="journey-ready-form" [class.is-nudge]="contactPhoneNudgeVisible"
            aria-label="Workspace details">
            <div class="journey-ready-setup-field">
              <div class="journey-ready-setup-label-row">
                <label class="journey-ready-setup-label" for="journey-workspace-name-input">{{ guideCopy.readyWorkspaceLabel }}</label>
                <span class="journey-ready-setup-meta" *ngIf="workspaceNameStatus === 'saving'">Saving…</span>
                <span class="journey-ready-setup-meta" *ngIf="workspaceNameStatus === 'saved'">Saved</span>
              </div>
              <input
                #workspaceNameInput
                id="journey-workspace-name-input"
                type="text"
                class="journey-ready-setup-input"
                [(ngModel)]="workspaceName"
                name="workspaceName"
                maxlength="80"
                placeholder="e.g. Acme Ops"
                autocomplete="organization"
                [readonly]="workspaceNameStatus === 'saving'"
                (focus)="workspaceNameEditing = true"
                (keydown.enter)="$event.preventDefault(); commitWorkspaceNameFromEdit()"
                (keydown.escape)="$event.preventDefault(); cancelWorkspaceNameEdit()"
                (blur)="commitWorkspaceNameFromEdit()" />
            </div>

            <div class="journey-ready-setup-field">
              <div class="journey-ready-setup-label-row">
                <label class="journey-ready-setup-label" id="journey-team-size-label">{{ guideCopy.readyTeamSizeLabel }}</label>
                <span class="journey-ready-setup-meta" *ngIf="teamSizeStatus === 'saving'">Saving…</span>
                <span class="journey-ready-setup-meta" *ngIf="teamSizeStatus === 'saved'">Saved</span>
              </div>
              <mat-select
                class="journey-ready-setup-input journey-team-size-select"
                panelClass="journey-phone-dial-panel journey-team-size-panel"
                [(ngModel)]="teamSize"
                name="teamSize"
                aria-labelledby="journey-team-size-label"
                placeholder="Select team size"
                [disabled]="teamSizeStatus === 'saving'"
                (selectionChange)="onTeamSizeSelected($event.value)">
                <mat-option [value]="''">Select team size</mat-option>
                <mat-option *ngFor="let option of teamSizeOptions" [value]="option.value">{{ option.label }}</mat-option>
              </mat-select>
            </div>

            <app-journey-contact-phone-strip
              #readyContactPhoneStrip
              class="journey-ready-setup-field"
              [class.is-needed]="!contactPhoneDisplay || contactPhoneNudgeVisible"
              variant="ready"
              source="ready"
              [label]="guideCopy.readyContactPhoneLabel"
              [hint]="guideCopy.readyContactPhoneHint"
              [showStatusPills]="false"
              [phoneValue]="contactPhoneSaved"
              [nudgeVisible]="contactPhoneNudgeVisible"
              [showSkip]="false"
              skipLabel="Continue without a number"
              nudgeCopy="Add your number so we can reach you, then continue."
              (saved)="onReadyContactPhoneSaved($event)"
              (skipped)="continueWithoutContactPhone()"
              (phoneChange)="onReadyContactPhoneDraft($event)" />
          </section>

          <div class="journey-actions journey-ready-actions">
            <p class="journey-ready-phone-note" *ngIf="isPhoneOrTabletReady">
              SuperSee desktop tracking runs on Windows, Mac, and Linux. Continue setup here — you’ll invite someone after Collection.
            </p>
            <button type="button" class="journey-btn-primary journey-btn-ready journey-btn-ready--block"
              [disabled]="isLoading"
              [attr.aria-describedby]="readyMissingFieldsShown && readyMissingHint ? 'journey-ready-missing' : null"
              (click)="continueFromReadyToUnderstand()">
              {{ guideCopy.readyContinueCta }} <mat-icon>arrow_forward</mat-icon>
            </button>
            <p class="journey-ready-missing" id="journey-ready-missing" role="alert"
              *ngIf="readyMissingFieldsShown && readyMissingHint">{{ readyMissingHint }}</p>
            <p class="journey-ready-next-caption">{{ guideCopy.readyNextCaption }}</p>
            <p class="journey-ready-assist-done" *ngIf="assistedSetupRequested">We’ll reach you to set this up.</p>
          </div>
        </div>
      </div>

      <!-- Purpose — why introduce SuperSee -->
      <div class="step-content journey-stage journey-ready journey-purpose" *ngIf="currentStepId === 'plan_viewed'">
        <div class="journey-ready-stage">
          <button class="journey-back" type="button" (click)="goBack()">
            <mat-icon>arrow_back</mat-icon> Back
          </button>
          <div class="journey-ready-hero">
            <h1 class="journey-display">{{ guideCopy.purposeHeadline }}</h1>
            <p class="journey-empathy">{{ guideCopy.purposeBody }}</p>
          </div>

          <div class="purpose-cards" role="listbox" [attr.aria-label]="guideCopy.purposeHeadline">
            <div
              class="mode-card purpose-choice"
              *ngFor="let purpose of trustFirstPurposes"
              role="option"
              [attr.aria-selected]="selectedPurposeId === purpose.id"
              [class.is-picked]="selectedPurposeId === purpose.id"
              (click)="selectTrustFirstPurpose(purpose.id)">
              <div class="mode-icon" [class.is-picked]="selectedPurposeId === purpose.id">
                <mat-icon aria-hidden="true">{{ purpose.icon }}</mat-icon>
              </div>
              <div class="purpose-choice-copy">
                <h3>{{ purpose.title }}</h3>
                <p>{{ purpose.description }}</p>
              </div>
            </div>
          </div>

          <div class="journey-actions journey-ready-actions">
            <button type="button" class="journey-btn-primary journey-btn-ready"
              [disabled]="isLoading || !canContinueFromPurpose"
              (click)="continueFromPurpose()">
              {{ guideCopy.purposeContinueCta }} <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <!-- Collection — pilot settings -->
      <div class="step-content journey-stage journey-flow journey-collection" *ngIf="currentStepId === 'collection'">
        <button class="journey-back" type="button" (click)="backFromCollection()">
          <mat-icon>arrow_back</mat-icon> Back
        </button>

        <ng-container>
          <p class="journey-kicker collection-beat-kicker">{{ collectionBeatLabel }}</p>
          <ol class="collection-progress" aria-hidden="true">
            <li *ngFor="let dot of collectionBeatDots" [class.is-done]="dot < collectionBeat" [class.is-current]="dot === collectionBeat"></li>
          </ol>
          <div class="journey-hero journey-hero-narrow">
            <h1 class="journey-display">{{ collectionBeatTitle }}</h1>
            <p class="journey-companion" *ngIf="collectionBeatBody">{{ collectionBeatBody }}</p>
          </div>

          <div class="mode-cards collection-choice-cards" *ngIf="collectionBeat === 0">
            <div class="mode-card" [class.is-picked]="collectionScreenshotsOn" (click)="collectionScreenshotsOn = true">
              <div class="mode-card-top">
                <div class="mode-icon" [class.is-picked]="collectionScreenshotsOn"><mat-icon>photo_camera</mat-icon></div>
                <span class="mode-radio" [class.is-on]="collectionScreenshotsOn" aria-hidden="true"></span>
              </div>
              <h3>{{ guideCopy.collectionShotsOnTitle }}</h3>
              <p>{{ guideCopy.collectionShotsOnDetail }}</p>
            </div>
            <div class="mode-card" [class.is-picked]="!collectionScreenshotsOn" (click)="collectionScreenshotsOn = false">
              <div class="mode-card-top">
                <div class="mode-icon" [class.is-picked]="!collectionScreenshotsOn"><mat-icon>image_not_supported</mat-icon></div>
                <span class="mode-radio" [class.is-on]="!collectionScreenshotsOn" aria-hidden="true"></span>
              </div>
              <h3>{{ guideCopy.collectionShotsOffTitle }}</h3>
              <p>{{ guideCopy.collectionShotsOffDetail }}</p>
            </div>
          </div>
          <div class="collection-interval-row" *ngIf="collectionBeat === 0 && collectionScreenshotsOn">
            <label [attr.for]="'collection-interval'">{{ guideCopy.collectionIntervalLabel }}</label>
            <input id="collection-interval" type="number" class="journey-ready-setup-input collection-interval"
              [(ngModel)]="collectionScreenshotInterval" name="collectionScreenshotInterval"
              [min]="screenshotIntervalFloor" />
            <span>minutes (minimum allowed {{ screenshotIntervalFloor }})</span>
          </div>

          <div class="mode-cards collection-choice-cards collection-choice-cards--three" *ngIf="collectionBeat === 1" role="radiogroup" [attr.aria-label]="guideCopy.collectionBeatModeTitle">
            <div
              class="mode-card"
              role="radio"
              tabindex="0"
              *ngFor="let option of collectionModeOptions; trackBy: trackByModeId"
              [class.is-picked]="collectionMode === option.id"
              [class.is-caution]="option.id === 'hidden'"
              [class.mode-card--locked]="option.locked"
              [attr.aria-checked]="collectionMode === option.id"
              [attr.aria-disabled]="option.locked"
              (click)="pickCollectionMode(option)"
              (keydown.enter)="pickCollectionMode(option)"
              (keydown.space)="pickCollectionMode(option); $event.preventDefault()">
              <div class="mode-card-top">
                <div class="mode-icon" [class.is-picked]="collectionMode === option.id"><mat-icon>{{ option.icon }}</mat-icon></div>
                <span class="mode-tag" *ngIf="option.recommended">{{ guideCopy.collectionModeRecommendedTag }}</span>
                <span class="mode-radio" [class.is-on]="collectionMode === option.id" aria-hidden="true"></span>
              </div>
              <h3>
                {{ option.label }}
                <mat-icon *ngIf="option.locked" class="mode-lock" aria-hidden="true">lock</mat-icon>
              </h3>
              <ul class="mode-facts">
                <li *ngFor="let fact of option.facts"><mat-icon aria-hidden="true">{{ fact.icon }}</mat-icon>{{ fact.text }}</li>
              </ul>
              <p class="mode-caution" *ngIf="option.caution">
                <mat-icon aria-hidden="true">info</mat-icon>{{ option.caution }}
              </p>
            </div>
          </div>

          <div class="collection-confirm" *ngIf="collectionBeat === 2">
            <section class="collection-confirm-card" aria-label="Pilot settings">
              <p class="collection-confirm-label">{{ guideCopy.collectionConfirmChosen }}</p>
              <ul class="confirm-list">
                <li class="confirm-item">
                  <span class="confirm-item-icon" aria-hidden="true"><mat-icon>{{ collectionScreenshotsOn ? 'photo_camera' : 'image_not_supported' }}</mat-icon></span>
                  <span class="confirm-item-copy">
                    <span class="confirm-item-title">{{ guideCopy.collectionConfirmShotsLabel }}</span>
                    <span class="confirm-item-detail">{{ collectionShotsSummary }}</span>
                  </span>
                  <button type="button" class="confirm-item-edit" (click)="goToCollectionBeat(0)"
                    [attr.aria-label]="guideCopy.collectionConfirmEdit + ' ' + guideCopy.collectionConfirmShotsLabel">{{ guideCopy.collectionConfirmEdit }}</button>
                </li>
                <li class="confirm-item">
                  <span class="confirm-item-icon" aria-hidden="true"><mat-icon>{{ collectionMode === 'hidden' ? 'visibility_off' : (collectionMode === 'admin_controlled' ? 'autorenew' : 'touch_app') }}</mat-icon></span>
                  <span class="confirm-item-copy">
                    <span class="confirm-item-title">{{ guideCopy.collectionConfirmModeLabel }}</span>
                    <span class="confirm-item-detail">{{ collectionModeLabel }}</span>
                  </span>
                  <button type="button" class="confirm-item-edit" (click)="goToCollectionBeat(1)"
                    [attr.aria-label]="guideCopy.collectionConfirmEdit + ' ' + guideCopy.collectionConfirmModeLabel">{{ guideCopy.collectionConfirmEdit }}</button>
                </li>
              </ul>

              <p class="collection-confirm-label">{{ guideCopy.collectionConfirmAlso }}</p>
              <ul class="confirm-list">
                <li class="confirm-item">
                  <span class="confirm-item-icon" aria-hidden="true"><mat-icon>apps</mat-icon></span>
                  <span class="confirm-item-copy">
                    <span class="confirm-item-title">{{ guideCopy.collectionConfirmApps }}</span>
                    <span class="confirm-item-detail">{{ guideCopy.collectionConfirmAppsDetail }}</span>
                  </span>
                  <button type="button" class="confirm-switch" role="switch" [class.is-on]="collectionAppsOn"
                    [attr.aria-checked]="collectionAppsOn" [attr.aria-label]="guideCopy.collectionConfirmApps"
                    (click)="collectionAppsOn = !collectionAppsOn"><span class="confirm-switch-thumb"></span></button>
                </li>
                <li class="confirm-item">
                  <span class="confirm-item-icon" aria-hidden="true"><mat-icon>schedule</mat-icon></span>
                  <span class="confirm-item-copy">
                    <span class="confirm-item-title">{{ guideCopy.collectionConfirmHours }}</span>
                    <span class="confirm-item-detail">{{ guideCopy.collectionConfirmHoursDetail }}</span>
                  </span>
                  <span class="confirm-item-fixed"><mat-icon aria-hidden="true">lock</mat-icon>{{ guideCopy.collectionConfirmHoursValue }}</span>
                </li>
                <li class="confirm-item">
                  <span class="confirm-item-icon" aria-hidden="true"><mat-icon>visibility</mat-icon></span>
                  <span class="confirm-item-copy">
                    <span class="confirm-item-title">{{ guideCopy.collectionConfirmLive }}</span>
                    <span class="confirm-item-detail">{{ guideCopy.collectionConfirmLiveDetail }}</span>
                  </span>
                  <button type="button" class="confirm-switch" role="switch" [class.is-on]="collectionLiveViewAllowed"
                    [attr.aria-checked]="collectionLiveViewAllowed" [attr.aria-label]="guideCopy.collectionConfirmLive"
                    (click)="collectionLiveViewAllowed = !collectionLiveViewAllowed"><span class="confirm-switch-thumb"></span></button>
                </li>
              </ul>

              <div class="collection-confirm-schedule" *ngIf="collectionShiftId">
                <p class="collection-confirm-label">{{ guideCopy.collectionConfirmSchedule }}</p>
                <div class="collection-time-grid">
                  <label class="collection-time-field">
                    <span>{{ guideCopy.collectionScheduleStarts }}</span>
                    <input type="time" [(ngModel)]="collectionShiftStart" name="collectionShiftStart" />
                  </label>
                  <label class="collection-time-field">
                    <span>{{ guideCopy.collectionScheduleEnds }}</span>
                    <input type="time" [(ngModel)]="collectionShiftEnd" name="collectionShiftEnd" />
                  </label>
                </div>
              </div>
              <p class="collection-confirm-note" *ngIf="!collectionShiftId">{{ guideCopy.collectionScheduleNoShift }}</p>
            </section>
          </div>

          <div class="journey-actions">
            <button type="button" class="journey-btn-primary"
              [disabled]="collectionSaveStatus === 'saving'"
              (click)="advanceCollectionBeat()">
              <ng-container *ngIf="collectionSaveStatus !== 'saving'; else collectionSavingLabel">
                {{ collectionBeat === collectionBeatDots.length - 1 ? guideCopy.collectionSaveCta : guideCopy.collectionNextCta }}
                <mat-icon>arrow_forward</mat-icon>
              </ng-container>
              <ng-template #collectionSavingLabel>Saving…</ng-template>
            </button>
          </div>
        </ng-container>
      </div>

      <!-- mode_education: auto-skipped before private proof; chooser used for Adjust mode -->
      <div class="step-content journey-stage" *ngIf="currentStepId === 'mode_education'">
        <ng-container *ngIf="modeEducationPage === 'choose' || adjustingModeFromReview; else modeEducationLegacy">
          <button class="journey-back" type="button" (click)="cancelModeAdjustment()" *ngIf="adjustingModeFromReview">
            <mat-icon>arrow_back</mat-icon> Back
          </button>
          <div class="journey-hero journey-hero-narrow">
            <p class="journey-kicker">Tracking mode</p>
            <h1 class="journey-display">Choose how SuperSee runs</h1>
            <p class="journey-companion">Same work visibility for you either way. What changes is what they see day to day. You can change this later.</p>
          </div>
          <div class="mode-cards journey-mode-cards">
            <div *ngFor="let mode of journeyModes; trackBy: trackByModeId" class="mode-card"
              [class.selected]="!mode.locked && selectedMode === mode.id"
              [class.mode-card--locked]="mode.locked"
              (click)="selectMode(mode.id)">
              <div class="mode-icon" [class.selected]="!mode.locked && selectedMode === mode.id">
                <mat-icon>{{ mode.icon }}</mat-icon>
              </div>
              <h3>
                {{ mode.title }}
                <mat-icon *ngIf="mode.locked" class="mode-lock" aria-hidden="true">lock</mat-icon>
              </h3>
              <p>{{ mode.description }}</p>
            </div>
          </div>
          <p class="journey-hint journey-mode-edu-adjust-note">
            {{ privateTestModeEducationNote }}
          </p>
          <p class="journey-hint journey-mode-edu-adjust-note">
            <strong>Visible</strong> = they can see SuperSee.
            <strong>Hidden</strong> = background on a work PC — still introduce SuperSee openly; not secret monitoring.
          </p>
          <div class="journey-actions">
            <button class="journey-btn-primary" [disabled]="!selectedMode || isLoading" (click)="confirmModeSelection()">
              <span *ngIf="!isLoading">Save mode <mat-icon>arrow_forward</mat-icon></span>
              <span *ngIf="isLoading">Saving…</span>
            </button>
          </div>
        </ng-container>
        <ng-template #modeEducationLegacy>
          <div class="journey-hero journey-hero-narrow">
            <p class="journey-kicker">Install</p>
            <h1 class="journey-display">Preparing install on this computer…</h1>
            <p class="journey-companion">{{ guideCopy.focusTime }}</p>
          </div>
          <div class="journey-actions">
            <button class="journey-btn-primary" (click)="skipModeEducationToInstall()">
              Continue to install <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
        </ng-template>
      </div>

      <!-- A2 Install / wait — Connected is a thin success beat -->
      <div class="step-content journey-stage" *ngIf="currentStepId === 'private_test'"
        [class.journey-connected-stage]="isAgentOnline">
        <button class="journey-back" (click)="goBack()"><mat-icon>arrow_back</mat-icon> Back</button>

        <!-- div not nav: Materialize global `nav { background: #ee6e73 }` -->
        <ng-template #privateTestProgress>
          <div class="journey-install-progress" role="status" aria-label="Install progress">
            <ol>
              <li
                [class.is-started]="installProgressDownloadStarted"
                [class.is-done]="installProgressDownloadDone"
                [class.is-current]="!isDownloaded && !isAgentOnline"
                [attr.aria-current]="!isDownloaded && !isAgentOnline ? 'step' : null">
                <span class="journey-install-progress-dot" aria-hidden="true"></span>
                <span class="journey-install-progress-label">{{ installDownloadChipLabel }}</span>
              </li>
              <li
                [class.is-done]="installProgressInstallDone"
                [class.is-current]="installProgressDownloadStarted"
                [attr.aria-current]="installProgressDownloadStarted ? 'step' : null">
                <span class="journey-install-progress-dot" aria-hidden="true"></span>
                <span class="journey-install-progress-label">Install</span>
              </li>
              <li
                [class.is-done]="installProgressConnectDone"
                [class.is-waiting]="installProgressDownloadStarted">
                <span class="journey-install-progress-dot" aria-hidden="true"></span>
                <span class="journey-install-progress-label">Connect</span>
              </li>
              <li [class.is-done]="false" [class.is-current]="isAgentOnline"
                [attr.aria-current]="isAgentOnline ? 'step' : null">
                <span class="journey-install-progress-dot" aria-hidden="true"></span>
                <span class="journey-install-progress-label">First screenshot</span>
              </li>
            </ol>
          </div>
        </ng-template>

        <!-- Connected: composed win → proof tease → one CTA -->
        <ng-container *ngIf="isAgentOnline">
          <ng-container *ngTemplateOutlet="privateTestProgress"></ng-container>
          <div class="journey-hero journey-hero-narrow journey-connected-hero">
            <p class="journey-kicker">Screenshot</p>
            <h1 class="journey-display">{{ guideCopy.installConnectedTitle }}</h1>
            <p class="journey-companion">{{ guideCopy.installConnectedBody }}</p>
          </div>

          <div class="journey-panel journey-panel--connected">
            <p class="journey-connected-status" role="status">
              <mat-icon aria-hidden="true">check_circle</mat-icon>
              <span>SuperSee is running on this computer</span>
            </p>
            <div class="journey-actions journey-connected-actions">
              <button type="button" class="journey-btn-primary" (click)="continuePrivateTestToProof()">
                {{ guideCopy.installConnectedCta }} <mat-icon>arrow_forward</mat-icon>
              </button>
            </div>
          </div>

          <div class="journey-connected-footer">
            <button type="button" class="journey-btn-quiet" (click)="continueLaterFromJourney()">Continue later</button>
            <span class="journey-connected-footer-sep" aria-hidden="true">·</span>
            <button type="button" class="journey-link" (click)="downloadRemovalUtility()">
              Remove from this computer
            </button>
          </div>
          <p class="journey-hint journey-connected-remove-note" *ngIf="removalDownloadStarted">{{ guideCopy.removeDisclosure }}</p>
        </ng-container>

        <!-- Waiting / install -->
        <ng-container *ngIf="!isAgentOnline">
          <div class="journey-hero journey-hero-narrow" *ngIf="privateTestUiState !== 'open_file'">
            <h1 class="journey-display">{{ guideCopy.installHeadline }}</h1>
            <p class="journey-companion">{{ journeyCompanionLine }}</p>
          </div>
          <ng-container *ngIf="privateTestUiState !== 'open_file'">
            <ng-container *ngTemplateOutlet="privateTestProgress"></ng-container>
          </ng-container>

          <div class="journey-hero journey-hero-narrow journey-open-hero" *ngIf="privateTestUiState === 'open_file'">
            <h1 class="journey-display">{{ guideCopy.installOpenTitle }}</h1>

            <ol class="open-steps">
              <!-- 1. Open the file — the browser Keep warning belongs here, before they hit it -->
              <li class="open-step">
                <p class="open-step-title">{{ guideCopy.installStepOpenTitle }}</p>
                <p class="open-step-detail">
                  {{ guideCopy.installStepOpenLookFor }}
                  <span class="open-file-name"><mat-icon aria-hidden="true">description</mat-icon>{{ installOpenFileLabel }}</span>
                  {{ guideCopy.installStepOpenInDownloads }}
                </p>
                <p class="open-step-note" *ngIf="isPrivateTestWindowsFamily()">{{ guideCopy.installBrowserKeepHint }}</p>
                <button type="button" class="journey-link open-step-link" (click)="downloadPrivateTestPackage()">
                  {{ guideCopy.installDownloadAgain }}
                </button>
              </li>

              <!-- 2. Sign in to the app -->
              <li class="open-step">
                <p class="open-step-title">{{ guideCopy.installStepSignInTitle }}</p>
            <section
              class="journey-private-login journey-private-login--open"
              *ngIf="privateTestLoginEmail || createdEmployeePassword; else privateTestLoginMissing"
              aria-label="Desktop login for this computer">
              <div class="journey-private-login-row" *ngIf="privateTestLoginEmail">
                <span class="journey-private-login-label">Email</span>
                <button type="button" class="journey-private-login-copy" (click)="copyToClipboard(privateTestLoginEmail, 'email')">
                  <span>{{ privateTestLoginEmail }}</span>
                  <mat-icon>{{ copiedField === 'email' ? 'check' : 'content_copy' }}</mat-icon>
                </button>
              </div>
              <div class="journey-private-login-row" *ngIf="createdEmployeePassword">
                <span class="journey-private-login-label">Password</span>
                <button
                  type="button"
                  class="journey-private-login-copy"
                  (click)="copyToClipboard(createdEmployeePassword, 'password')">
                  <span>{{ createdEmployeePassword }}</span>
                  <mat-icon>{{ copiedField === 'password' ? 'check' : 'content_copy' }}</mat-icon>
                </button>
              </div>
              <p class="journey-private-login-hint" *ngIf="!createdEmployeePassword">{{ guideCopy.privateTestLoginPrepare }}</p>
              <button type="button" class="journey-btn-primary" *ngIf="!createdEmployeePassword" (click)="downloadPrivateTestPackage()">
                Download again
              </button>
              <p class="open-step-warn">
                <mat-icon aria-hidden="true">info</mat-icon>{{ guideCopy.installStepSignInNotAdmin }}
              </p>
            </section>
            <ng-template #privateTestLoginMissing>
              <section class="journey-private-login journey-private-login--open" aria-label="Desktop login for this computer">
                <p class="journey-private-login-hint">{{ guideCopy.privateTestLoginPrepare }}</p>
                <button type="button" class="journey-btn-primary" (click)="downloadPrivateTestPackage()">
                  Download again
                </button>
              </section>
            </ng-template>
              </li>

              <!-- 3. Wait — the live status is part of the flow, not a footnote -->
              <li class="open-step">
                <p class="open-step-title">{{ guideCopy.installStepWaitTitle }}</p>
            <p class="journey-open-wait" role="status">
              <mat-icon [class.spinning]="isCheckingStatus || pollingActive" aria-hidden="true">
                {{ (isCheckingStatus || pollingActive) ? 'sync' : 'hourglass_empty' }}
              </mat-icon>
              <span>
                <strong>
                  {{ privateTestIsHidden ? guideCopy.installWaitingTitleHidden : guideCopy.installWaitingTitle }}
                  <span class="journey-open-elapsed" *ngIf="connectWaitElapsedLabel" aria-hidden="true">{{ connectWaitElapsedLabel }}</span>
                </strong>
                {{ privateTestIsHidden ? guideCopy.installWaitingBodyHidden : guideCopy.installWaitingBody }}
              </span>
            </p>
              </li>
            </ol>
          </div>

          <!-- need_package / ready_download -->
          <div class="journey-panel journey-panel--download" *ngIf="privateTestUiState === 'need_package' || privateTestUiState === 'ready_download'">
            <p class="journey-install-os" role="status">
              <span class="journey-os-mark" [attr.data-os]="getPrivateTestOs()" aria-hidden="true">
                <span class="journey-os-windows" *ngIf="isPrivateTestWindowsFamily()">
                  <i></i><i></i><i></i><i></i>
                </span>
                <mat-icon *ngIf="!isPrivateTestWindowsFamily()">{{ privateTestOsIcon }}</mat-icon>
              </span>
              <span>{{ privateTestDetectedOsCopy }}</span>
            </p>
            <div class="journey-actions journey-install-download-actions">
              <button type="button" class="journey-btn-primary" [disabled]="isLoading || isDownloading || installDownloadCtaLocked" (click)="downloadPrivateTestPackage()">
                <mat-icon [class.spinning]="isLoading || isDownloading">{{ (isLoading || isDownloading) ? 'sync' : privateTestOsIcon }}</mat-icon>
                {{ getPrivateTestDownloadLabel() }}
              </button>
            </div>
            <p class="journey-install-publisher">{{ guideCopy.installPublisher }}</p>
            <p class="journey-install-notes">
              <span>{{ guideCopy.installTrust }}</span>
              <span>{{ guideCopy.installModeLater }}</span>
            </p>

            <ng-container *ngTemplateOutlet="privateTestLoginFold"></ng-container>

            <div class="journey-install-av-fold" *ngIf="isPrivateTestWindowsFamily()">
              <button
                type="button"
                class="journey-link journey-install-av-toggle"
                (click)="toggleInstallAntivirusTip()"
                [attr.aria-expanded]="installAntivirusOpen">
                {{ guideCopy.installAntivirusLink }}
              </button>
              <p class="journey-install-av-tip" *ngIf="installAntivirusOpen" role="note">
                {{ guideCopy.installAntivirusTip }}
              </p>
            </div>
          </div>

          <!-- open_file: help + recovery (the three steps live in the hero above) -->
          <div class="journey-open-body" *ngIf="privateTestUiState === 'open_file'">
            <div class="journey-open-actions">
              <button type="button" class="journey-link" *ngIf="!showInstallHelp"
                (click)="toggleInstallOpenHelp()"
                [attr.aria-expanded]="installOpenHelpOpen">
                {{ installOpenHelpOpen ? guideCopy.installOpenHelpHide : guideCopy.installOpenHelp }}
              </button>
            </div>

            <div class="journey-install-open-help" *ngIf="installOpenHelpOpen && !showInstallHelp">
              <p class="journey-file-match" *ngIf="lastDownloadedPackageName">File name: {{ lastDownloadedPackageName }}</p>
              <ol class="journey-steps-ol" *ngIf="isPrivateTestWindowsFamily()">
                <li>If Windows asks for permission, choose Yes.</li>
                <li>If SmartScreen appears, choose More info, then Run anyway.</li>
              </ol>
              <ol class="journey-steps-ol" *ngIf="getPrivateTestOs() === 'mac'">
                <li>If macOS blocks the file, right-click → Open.</li>
                <li>Allow SuperSee under Accessibility and Screen & Audio Recording in System Settings.</li>
              </ol>
              <ol class="journey-steps-ol" *ngIf="getPrivateTestOs() === 'linux'">
                <li>Allow running the file as a program if asked.</li>
                <li>Enter your system password if prompted.</li>
              </ol>
            </div>

            <div class="journey-open-recovery" *ngIf="showInstallHelp">
              <p class="journey-open-recovery-title">{{ guideCopy.installHelpTitle }}</p>
              <div class="journey-open-recovery-list">
                <button type="button" class="journey-open-recovery-item" [class.is-selected]="installRecoveryBranch === 'not_opened'"
                  (click)="selectInstallRecovery('not_opened')">I cannot find the downloaded file</button>
                <button type="button" class="journey-open-recovery-item" [class.is-selected]="installRecoveryBranch === 'uac_denied'"
                  (click)="selectInstallRecovery('uac_denied')">Windows stopped the installation</button>
                <button type="button" class="journey-open-recovery-item" [class.is-selected]="installRecoveryBranch === 'av_blocked'"
                  (click)="selectInstallRecovery('av_blocked')">My Antivirus blocked it</button>
                <button type="button" class="journey-open-recovery-item" [class.is-selected]="installRecoveryBranch === 'pending'"
                  (click)="selectInstallRecovery('pending')">I installed it, but it is not connecting</button>
              </div>
              <ol class="journey-steps-ol" *ngIf="installRecoveryBranch && installRecoveryBranch !== 'continue_later'">
                <li *ngFor="let step of getInstallRecoverySteps(installRecoveryBranch)">{{ step }}</li>
              </ol>
              <button type="button" class="journey-btn-quiet" *ngIf="installRecoveryBranch && installRecoveryBranch !== 'continue_later'"
                (click)="openInstallSupport()">
                Still stuck — send us the details
              </button>
            </div>

            <div class="journey-exit-nudge" *ngIf="privateTestExitNudgeVisible" role="note">
              <p class="journey-exit-nudge-title">{{ guideCopy.privateTestExitNudgeTitle }}</p>
              <p>{{ guideCopy.privateTestExitNudgeBody }}</p>
              <button type="button" class="journey-btn-primary" (click)="stayForPrivateTest()">
                {{ guideCopy.privateTestExitNudgeStay }}
              </button>
            </div>

            <div class="journey-open-footer">
              <button type="button" class="journey-btn-quiet" *ngIf="connectionCheckTimedOut"
                [disabled]="isCheckingStatus" (click)="checkAgentStatus()">
                <mat-icon [class.spinning]="isCheckingStatus">sync</mat-icon>
                {{ isCheckingStatus ? 'Checking…' : 'Check again' }}
              </button>
              <button type="button" class="journey-btn-quiet" (click)="continueLaterFromJourney()">Continue later</button>
            </div>
          </div>

          <div class="journey-exit-nudge" *ngIf="privateTestExitNudgeVisible && privateTestUiState !== 'open_file'" role="note">
            <p class="journey-exit-nudge-title">{{ guideCopy.privateTestExitNudgeTitle }}</p>
            <p>{{ guideCopy.privateTestExitNudgeBody }}</p>
            <button type="button" class="journey-btn-primary" (click)="stayForPrivateTest()">
              {{ guideCopy.privateTestExitNudgeStay }}
            </button>
          </div>

          <div class="journey-actions journey-install-wait-actions" *ngIf="privateTestUiState !== 'open_file'">
            <button class="journey-btn-quiet" *ngIf="connectionCheckTimedOut"
              [disabled]="isCheckingStatus" (click)="checkAgentStatus()">
              <mat-icon [class.spinning]="isCheckingStatus">sync</mat-icon>
              {{ isCheckingStatus ? 'Checking…' : 'Check again' }}
            </button>
            <button type="button" class="journey-btn-quiet" (click)="continueLaterFromJourney()">Continue later</button>
          </div>

          <ng-template #privateTestLoginFold>
            <div class="journey-private-login-fold" *ngIf="createdEmployee?.email">
              <button
                type="button"
                class="journey-link journey-private-login-toggle"
                (click)="togglePrivateTestLogin()"
                [attr.aria-expanded]="privateTestLoginOpen">
                <ng-container *ngIf="!privateTestLoginOpen">{{ guideCopy.privateTestLoginShow }}</ng-container>
                <ng-container *ngIf="privateTestLoginOpen">{{ guideCopy.privateTestLoginHide }}</ng-container>
              </button>
              <section
                class="journey-private-login"
                *ngIf="privateTestLoginOpen"
                aria-label="Desktop login for this computer">
                <p class="journey-private-login-hint">{{ guideCopy.privateTestLoginDetails }}</p>
                <button type="button" class="journey-private-login-copy" (click)="copyToClipboard(createdEmployee.email, 'email')">
                  <span>{{ createdEmployee.email }}</span>
                  <mat-icon>{{ copiedField === 'email' ? 'check' : 'content_copy' }}</mat-icon>
                </button>
                <button
                  type="button"
                  class="journey-private-login-copy"
                  *ngIf="createdEmployeePassword"
                  (click)="copyToClipboard(createdEmployeePassword, 'password')">
                  <span>{{ createdEmployeePassword }}</span>
                  <mat-icon>{{ copiedField === 'password' ? 'check' : 'content_copy' }}</mat-icon>
                </button>
                <p class="journey-private-login-hint" *ngIf="!createdEmployeePassword">{{ guideCopy.privateTestLoginPrepare }}</p>
                <button type="button" class="journey-link" *ngIf="!createdEmployeePassword" (click)="downloadPrivateTestPackage()">
                  Download again
                </button>
              </section>
            </div>
          </ng-template>
        </ng-container>
      </div>

      <!-- A3 Screenshot proof -->
      <div class="step-content journey-stage journey-proof-stage" *ngIf="currentStepId === 'private_proof'">
        <button class="journey-back" (click)="goBack()"><mat-icon>arrow_back</mat-icon> Back</button>

        <!-- Before capture -->
        <ng-container *ngIf="!(isScreenshotCaptured || privateProofEvidence)">
          <div class="journey-hero journey-hero-proof">
            <h1 class="journey-display">{{ guideCopy.proofCaptureTitle }}</h1>
            <p class="journey-companion">{{ guideCopy.safeScreen }}</p>
          </div>
          <div
            class="journey-panel journey-panel--proof"
            *ngIf="!screenshotFailed && !isRequestingScreenshot && !isResolvingScreenshotTarget">
            <p class="journey-proof-reassure" role="note">
              No typed passwords as keystrokes. Webcam stays off by default.
            </p>
            <div class="journey-actions journey-proof-capture-actions">
              <button type="button" class="journey-btn-primary" (click)="requestScreenshot()">
                <mat-icon>photo_camera</mat-icon>
                {{ guideCopy.proofCaptureCta }}
              </button>
            </div>
          </div>

          <div
            class="journey-wait-panel is-waiting"
            *ngIf="!screenshotFailed && (isRequestingScreenshot || isResolvingScreenshotTarget)">
            <div class="journey-wait-status">
              <mat-icon class="spinning" aria-hidden="true">sync</mat-icon>
              <div>
                <strong>Taking screenshot…</strong>
                <p>{{ guideCopy.proofCaptureWaiting }}</p>
              </div>
            </div>
          </div>

          <div class="journey-panel journey-panel--proof is-warn" *ngIf="screenshotFailed">
            <p class="journey-proof-missed" role="status">
              <mat-icon aria-hidden="true">error_outline</mat-icon>
              <span>
                <strong>{{ guideCopy.proofCaptureMissedTitle }}</strong>
                {{ guideCopy.proofCaptureMissedBody }}
              </span>
            </p>
            <ol class="journey-steps-ol journey-proof-recovery-steps">
              <li>{{ guideCopy.proofCaptureCheckAgent }}</li>
              <li>{{ proofCapturePermissionCopy }}</li>
            </ol>
            <div class="journey-actions journey-proof-recovery-actions">
              <button
                type="button"
                class="journey-btn-primary"
                [disabled]="isRequestingScreenshot || isResolvingScreenshotTarget"
                (click)="requestScreenshot()">
                <mat-icon>photo_camera</mat-icon>
                Try again
              </button>
              <button type="button" class="journey-btn-quiet" (click)="continueLaterFromJourney()">
                Continue later
              </button>
            </div>
            <button
              type="button"
              class="journey-link journey-proof-support-link"
              *ngIf="screenshotRequestCount >= 2"
              (click)="contactScreenshotSupport()">
              Need help?
            </button>
          </div>
        </ng-container>

        <!-- After capture: proof visual + one clear next action -->
        <ng-container *ngIf="isScreenshotCaptured || privateProofEvidence">
          <div class="journey-hero journey-hero-proof">
            <p class="journey-kicker">This computer</p>
            <h1 class="journey-display">{{ guideCopy.proofReadyTitle }}</h1>
            <p class="journey-companion">{{ guideCopy.proofWorking }}</p>
          </div>

          <div class="journey-proof-win" role="region" aria-label="First screenshot from this computer">
            <div
              class="journey-proof-visual"
              [class.has-image]="proofHasPreview"
              [class.is-receipt]="!proofHasPreview">
              <ng-container *ngIf="proofHasPreview; else proofReceipt">
                <img
                  [src]="privateProofEvidence?.imgURL"
                  alt="Screenshot captured from this computer"
                  class="journey-proof-image"
                  (error)="onProofPreviewError()" />
                <dl class="journey-proof-facts">
                  <div>
                    <dt>When</dt>
                    <dd>{{ formatProofCapturedAt(privateProofEvidence?.capturedAt) }}</dd>
                  </div>
                  <div>
                    <dt>App in front</dt>
                    <dd>{{ privateProofEvidence?.appName || 'This computer' }}</dd>
                  </div>
                  <div>
                    <dt>Who</dt>
                    <dd>Only you</dd>
                  </div>
                </dl>
              </ng-container>
              <ng-template #proofReceipt>
                <div class="journey-proof-receipt">
                  <mat-icon class="journey-proof-receipt-check" aria-hidden="true">check_circle</mat-icon>
                  <strong>{{ guideCopy.proofBridgeTitle }}</strong>
                  <p class="journey-proof-receipt-app">{{ privateProofEvidence?.appName || 'This computer' }}</p>
                  <p class="journey-proof-receipt-when">{{ formatProofCapturedAt(privateProofEvidence?.capturedAt) }}</p>
                  <p class="journey-proof-receipt-note">
                    Screenshot received
                    <ng-container *ngIf="privateProofEvidence?.screenshotId"> · ID {{ privateProofEvidence?.screenshotId }}</ng-container>
                    · preview can open in Screenshots
                  </p>
                  <div class="journey-proof-receipt-actions">
                    <button type="button" class="journey-btn-quiet" (click)="retryProofPreview()">Retry preview</button>
                    <button type="button" class="journey-btn-quiet" (click)="openPrivateTestScreenshots()">Open Screenshots</button>
                  </div>
                </div>
              </ng-template>
            </div>

            <div class="journey-actions journey-proof-next-actions">
              <button type="button" class="journey-btn-primary" (click)="chooseProofForkOneEmployee()">
                {{ guideCopy.proofAddEmployeeCta }} <mat-icon>arrow_forward</mat-icon>
              </button>
              <button type="button" class="journey-btn-quiet" (click)="chooseProofForkPrivateReview()">
                {{ guideCopy.proofKeepReviewingLink }}
              </button>
            </div>

            <section
              class="journey-proof-phone"
              *ngIf="showProofContactPhone"
              aria-label="Mobile number for Daily Insights on WhatsApp">
              <app-journey-contact-phone-strip
                #proofContactPhoneStrip
                variant="proof"
                source="private_proof"
                [title]="guideCopy.proofContactPhoneTitle"
                [hint]="guideCopy.proofContactPhoneHint"
                [skipLabel]="guideCopy.proofContactPhoneSkip"
                [showSkip]="true"
                [phoneValue]="contactPhoneSaved"
                (saved)="onProofContactPhoneSaved($event)"
                (skipped)="onProofContactPhoneSkipped()"
                (phoneChange)="onReadyContactPhoneDraft($event)" />
            </section>

            <details class="journey-proof-more-details">
              <summary>{{ guideCopy.afterProofMoreLabel }}</summary>
              <ul class="journey-proof-more-list">
                <li>
                  <button type="button" class="journey-link" (click)="openExampleWorkday()">
                    {{ guideCopy.afterProofSampleLink }}
                  </button>
                </li>
                <li>
                  <button type="button" class="journey-link" (click)="downloadRemovalUtility()">
                    Remove from this computer
                  </button>
                </li>
              </ul>
            </details>
          </div>
        </ng-container>
      </div>

      <!-- B1 Before employee — fair-use guidance threshold -->
      <!-- Access — who can see whom -->
      <div class="step-content journey-stage journey-flow journey-setup-confirm journey-access" *ngIf="currentStepId === 'setup_confirmed'">
        <button class="journey-back" (click)="goBack()"><mat-icon>arrow_back</mat-icon> Back</button>
        <div class="journey-hero journey-hero-narrow">
          <h1 class="journey-display">{{ guideCopy.accessHeadline }}</h1>
          <p class="journey-companion">{{ guideCopy.accessBody }}</p>
        </div>

        <div class="access-teams" *ngIf="accessTeams.length; else accessEmpty">
          <div class="access-team-row" *ngFor="let team of accessTeams">
            <strong>{{ team.name }}</strong>
            <p class="journey-hint">
              Managers: {{ team.managerLabel }}
              · Leads: {{ team.leadLabel }}
            </p>
          </div>
          <button type="button" class="journey-link" (click)="openTeamsFromAccess()">Manage teams</button>
        </div>
        <ng-template #accessEmpty>
          <p class="journey-hint">{{ guideCopy.accessEmptyTeams }}</p>
        </ng-template>

        <div class="journey-fair-next access-coaching" role="note">
          <p class="journey-fair-next-body">{{ guideCopy.accessCoaching }}</p>
        </div>

        <div class="journey-actions">
          <button type="button" class="journey-btn-primary" (click)="continueAccess()">
            {{ guideCopy.accessContinueCta }} <mat-icon>arrow_forward</mat-icon>
          </button>
        </div>
      </div>

      <!-- Announce — settings-aware team note -->
      <div class="step-content journey-stage journey-flow journey-announce" *ngIf="currentStepId === 'announce'">
        <button class="journey-back" (click)="goBack()"><mat-icon>arrow_back</mat-icon> Back</button>
        <div class="journey-hero journey-hero-narrow">
          <h1 class="journey-display">{{ guideCopy.announceHeadline }}</h1>
          <p class="journey-companion">{{ guideCopy.announceBody }}</p>
        </div>

        <section class="announce-sheet" aria-label="Team note">
          <p class="announce-sheet-label">{{ guideCopy.announceFactsTitle }}</p>
          <dl class="announce-facts">
            <div *ngFor="let fact of announcementFacts" [class.is-caution]="fact.caution">
              <dt>{{ fact.label }}</dt>
              <dd>{{ fact.value }}</dd>
            </div>
          </dl>

          <article class="announce-letter" *ngIf="!announceEditing">
            <header class="announce-letter-head">
              <div>
                <p class="announce-letter-kicker">{{ guideCopy.announcePreviewLabel }}</p>
                <p class="announce-letter-subject">Introducing SuperSee</p>
              </div>
              <button type="button" class="journey-link" (click)="announceEditing = true">
                {{ guideCopy.announceEditCta }}
              </button>
            </header>
            <div class="announce-letter-body">
              <p *ngFor="let para of announcementParagraphs">{{ para }}</p>
            </div>
          </article>

          <div class="announce-editor" *ngIf="announceEditing">
            <textarea
              class="announce-textarea"
              rows="12"
              spellcheck="false"
              autocomplete="off"
              [(ngModel)]="announcementDraft"
              name="announcementDraft"
              (ngModelChange)="onAnnouncementDraftChange($event)"></textarea>
            <div class="announce-editor-actions">
              <button type="button" class="journey-link" (click)="resetAnnouncementDraft()">
                {{ guideCopy.announceResetCta }}
              </button>
              <button type="button" class="journey-btn-quiet" (click)="announceEditing = false">
                {{ guideCopy.announceDoneEditingCta }}
              </button>
            </div>
          </div>

          <!-- Two equal ways to share the note, attached to the note itself -->
          <div class="announce-share-row">
            <button type="button" class="announce-share-btn" (click)="copyAnnouncementText()">
              <mat-icon aria-hidden="true">content_copy</mat-icon>{{ guideCopy.announceCopyCta }}
            </button>
            <button type="button" class="announce-share-btn" (click)="openAnnouncementEmailDraft()">
              <mat-icon aria-hidden="true">mail</mat-icon>{{ guideCopy.announceEmailCta }}
            </button>
          </div>
        </section>

        <button type="button" class="announce-disclosure" (click)="showAnnounceFaq = !showAnnounceFaq"
          [attr.aria-expanded]="showAnnounceFaq">
          <span>{{ guideCopy.announceFaqTitle }}</span>
          <mat-icon>{{ showAnnounceFaq ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
        <section class="announce-faq" *ngIf="showAnnounceFaq" aria-labelledby="announce-faq-heading">
          <h2 id="announce-faq-heading" class="sr-only">{{ guideCopy.announceFaqTitle }}</h2>
          <p class="announce-faq-hint">{{ guideCopy.announceFaqHint }}</p>
          <div class="announce-faq-item" *ngFor="let item of announcementFaq">
            <strong>{{ item.question }}</strong>
            <p>{{ item.answer }}</p>
          </div>
          <button type="button" class="announce-share-btn announce-section-copy" (click)="copyAnnouncementFaq()">
            <mat-icon aria-hidden="true">content_copy</mat-icon>{{ guideCopy.announceCopyFaqCta }}
          </button>
        </section>

        <button type="button" class="announce-disclosure" (click)="showAnnounceAck = !showAnnounceAck"
          [attr.aria-expanded]="showAnnounceAck">
          <span>{{ guideCopy.announceAckTitle }}</span>
          <mat-icon>{{ showAnnounceAck ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
        <div class="announce-ack" *ngIf="showAnnounceAck">
          <p class="announce-faq-hint">{{ guideCopy.announceAckLabel }}</p>
          <blockquote class="announce-ack-text">{{ announcementAckTemplate }}</blockquote>
          <button type="button" class="announce-share-btn announce-section-copy" (click)="copyAnnouncementAck()">
            <mat-icon aria-hidden="true">content_copy</mat-icon>{{ guideCopy.announceCopyAckCta }}
          </button>
        </div>

        <!-- The one action that moves the journey on -->
        <div class="journey-actions announce-continue">
          <button type="button" class="journey-btn-primary" (click)="completeAnnounceShared()">
            {{ guideCopy.announceSharedCta }} <mat-icon>arrow_forward</mat-icon>
          </button>
        </div>

        <div class="announce-skip-wrap">
          <button type="button" class="journey-link" (click)="completeAnnounceSkipped()">
            {{ guideCopy.announceSkipCta }}
          </button>
        </div>
      </div>

      <!-- B2 Add first employee — canonical Employees handoff -->
      <!-- B3 First employee -->
      <div class="step-content journey-stage journey-flow journey-hire-stage" *ngIf="currentStepId === 'first_employee'">
        <button class="journey-back" (click)="goBack()"><mat-icon>arrow_back</mat-icon> Back</button>

        <ng-container *ngIf="!hasRealFirstEmployee">
          <ng-container *ngIf="!journeyState?.wantsEmployeeInvite; else inviteAfterNote">
            <div class="journey-hero journey-hero-narrow">
              <h1 class="journey-display">{{ guideCopy.seeItHeadline }}</h1>
              <p class="journey-companion">{{ guideCopy.seeItBody }}</p>
            </div>
            <div class="mode-cards collection-choice-cards see-it-cards">
              <button type="button" class="mode-card see-it-card is-recommended" *ngIf="!isPhoneOrTabletReady"
                (click)="startPrivateTestFromReady()">
                <div class="mode-icon"><mat-icon>computer</mat-icon></div>
                <span class="mode-tag">{{ guideCopy.collectionModeRecommendedTag }}</span>
                <h3>{{ guideCopy.seeItThisPcTitle }}</h3>
                <p>{{ guideCopy.seeItThisPcDetail }}</p>
                <span class="see-it-cta">{{ guideCopy.seeItThisPcCta }} <mat-icon aria-hidden="true">arrow_forward</mat-icon></span>
              </button>
              <button type="button" class="mode-card see-it-card"
                [class.is-recommended]="isPhoneOrTabletReady"
                (click)="chooseInviteEmployee()">
                <div class="mode-icon"><mat-icon>person_add</mat-icon></div>
                <h3>{{ guideCopy.seeItInviteTitle }}</h3>
                <p>{{ guideCopy.seeItInviteDetail }}</p>
                <span class="see-it-cta">{{ guideCopy.seeItInviteCta }} <mat-icon aria-hidden="true">arrow_forward</mat-icon></span>
              </button>
            </div>
            <p class="see-it-footnote">{{ guideCopy.seeItFootnote }}</p>
          </ng-container>
          <ng-template #inviteAfterNote>
          <div class="journey-hero journey-hero-narrow journey-hire-hero">
            <h1 class="journey-display" #firstEmployeeHeading tabindex="-1">{{ guideCopy.invitePilotHeadline }}</h1>
            <p class="journey-companion">{{ invitePilotCompanion }}</p>
          </div>

          <section class="journey-hire-recovery" [attr.aria-label]="guideCopy.invitePilotCta">
            <div class="journey-actions journey-hire-form-actions">
              <button class="journey-btn-primary" type="button" (click)="openAddEmployeeHandoffWithWarn()">
                {{ guideCopy.invitePilotCta }} <mat-icon>arrow_forward</mat-icon>
              </button>
              <button type="button" class="journey-btn-quiet"
                *ngIf="showDesktopPrivateTestFromInvite"
                (click)="startPrivateTestFromReady()">
                {{ guideCopy.invitePrivateTestCta }}
              </button>
              <button class="journey-btn-quiet" type="button" (click)="continueLaterFromJourney()">
                Continue later
              </button>
            </div>
          </section>

          <div class="invite-warn" *ngIf="showInviteAnnounceWarn" role="dialog" aria-labelledby="invite-warn-title">
            <h2 id="invite-warn-title" class="journey-fair-guide-heading">{{ guideCopy.inviteWarnTitle }}</h2>
            <p>{{ guideCopy.inviteWarnBody }}</p>
            <p *ngIf="journeyState?.pilotTrayOff">{{ guideCopy.inviteWarnTrayOff }}</p>
            <div class="journey-actions">
              <button type="button" class="journey-btn-primary" (click)="goBackToAnnounceFromInviteWarn()">
                {{ guideCopy.inviteWarnBack }}
              </button>
              <button type="button" class="journey-btn-quiet" (click)="dismissInviteWarnAndOpenAdd()">
                {{ guideCopy.inviteWarnAnyway }}
              </button>
            </div>
          </div>
          </ng-template>
        </ng-container>

        <div class="journey-hire-visibility-nudge" *ngIf="showEmployeeVisibilityNudge" role="note">
          <p>{{ guideCopy.visibilitySwitchTeach }}</p>
          <button type="button" class="journey-btn-quiet" (click)="dismissEmployeeVisibilityNudge()">
            {{ guideCopy.visibilitySwitchGotIt }}
          </button>
        </div>

        <ng-container *ngIf="hasRealFirstEmployee">
          <div class="journey-hero journey-hero-narrow journey-hire-hero" [class.journey-hire-hero--wait]="!isAgentOnline">
            <p class="journey-kicker">{{ isAgentOnline ? 'Connected' : 'One employee added' }}</p>
            <h1 class="journey-display" #firstEmployeeHeading tabindex="-1">
              {{ isAgentOnline ? 'First connection live' : 'Finish setup on their computer' }}
            </h1>
            <p class="journey-companion" *ngIf="!isAgentOnline">{{ firstEmployeeWaitingCompanion }}</p>
            <p class="journey-companion" *ngIf="isAgentOnline">
              They’re live. Review unlocks after enough real work activity — not from connection alone.
            </p>
          </div>

          <!-- Waiting: one composition — person, quiet status, deferred help -->
          <div class="journey-hire-wait" *ngIf="!isAgentOnline">
            <div class="journey-hire-person" role="group" [attr.aria-label]="firstEmployeeDisplayName">
              <span class="journey-hire-avatar" aria-hidden="true">{{ firstEmployeeInitials }}</span>
              <div class="journey-hire-person-text">
                <strong>{{ firstEmployeeDisplayName }}</strong>
                <button
                  type="button"
                  class="copy-item journey-hire-person-email"
                  *ngIf="isEmployeeRunsDelivery && createdEmployee?.email"
                  [attr.aria-label]="copiedField === 'email' ? 'Email copied' : 'Copy employee email'"
                  (click)="copyToClipboard(createdEmployee.email, 'email')">
                  {{ createdEmployee.email }}
                  <mat-icon class="copy-icon" aria-hidden="true">{{ copiedField === 'email' ? 'check' : 'content_copy' }}</mat-icon>
                </button>
              </div>
            </div>

            <div class="journey-hire-file" *ngIf="canRedownloadSetupFile">
              <span class="journey-hire-file-icon" aria-hidden="true"><mat-icon>download</mat-icon></span>
              <div class="journey-hire-file-text">
                <strong>SuperSee Setup</strong>
                <span>For {{ firstEmployeeDisplayName }}’s computer</span>
              </div>
              <button type="button" class="journey-btn-primary journey-hire-file-btn" (click)="getSetupFile()">
                Get setup file
              </button>
            </div>

            <p class="journey-open-wait" role="status" aria-live="polite" aria-atomic="true">
              <span class="journey-live-dot"
                [class.is-live]="isCheckingStatus || pollingActive"
                [class.is-stalled]="connectionCheckTimedOut"
                aria-hidden="true"></span>
              <span class="journey-open-wait-text">
                <strong>{{ connectionStatusLabel }}</strong>
                {{ firstEmployeeWaitBody }}
              </span>
            </p>

            <button
              type="button"
              class="journey-hire-helpbtn"
              *ngIf="isHeroInstallsDelivery && !showConnectionRecovery"
              (click)="showMissingSetupFileHelp = !showMissingSetupFileHelp"
              [attr.aria-expanded]="showMissingSetupFileHelp">
              <span>{{ showMissingSetupFileHelp ? 'Hide setup file help' : "Didn't get the setup file?" }}</span>
              <mat-icon aria-hidden="true">{{ showMissingSetupFileHelp ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>

            <div class="journey-hire-help" *ngIf="isHeroInstallsDelivery && showMissingSetupFileHelp && !showConnectionRecovery">
              <p>
                If the browser blocked the download, allow downloads for this site, then create a fresh setup file.
                Use only the new file on their computer.
              </p>
              <button
                type="button"
                class="journey-btn-quiet"
                [disabled]="isReissuingPackage"
                (click)="createFreshFirstEmployeePackage()">
                {{ isReissuingPackage ? 'Creating…' : 'Create a fresh setup file' }}
              </button>
            </div>

            <div class="journey-open-recovery" *ngIf="showConnectionRecovery">
              <p class="journey-open-recovery-title">Still waiting?</p>
              <p class="journey-hint" *ngIf="isHeroInstallsDelivery">
                Confirm the setup ran on their computer and SuperSee is still open there.
              </p>
              <p class="journey-hint" *ngIf="isEmployeeRunsDelivery">
                Confirm they opened the credentials email, installed, and signed in.
              </p>
              <div class="journey-open-footer">
                <button
                  type="button"
                  class="journey-btn-quiet"
                  [disabled]="isCheckingStatus"
                  (click)="checkAgentStatus()">
                  <mat-icon [class.spinning]="isCheckingStatus" aria-hidden="true">sync</mat-icon>
                  {{ isCheckingStatus ? 'Checking…' : 'Check again' }}
                </button>
                <button
                  type="button"
                  class="journey-btn-quiet"
                  *ngIf="isEmployeeRunsDelivery || isHeroInstallsDelivery"
                  [disabled]="isReissuingPackage"
                  (click)="createFreshFirstEmployeePackage()">
                  {{ isReissuingPackage ? 'Creating…' : 'Create a fresh setup file' }}
                </button>
              </div>
            </div>

            <div class="journey-hire-footer">
              <button type="button" class="journey-hire-later" (click)="continueLaterFromJourney()">
                Continue later
              </button>
            </div>
          </div>

          <!-- Connected: thin success + one CTA -->
          <ng-container *ngIf="isAgentOnline">
            <div class="journey-panel journey-panel--connected">
              <p class="journey-connected-status" role="status">
                <mat-icon aria-hidden="true">check_circle</mat-icon>
                <span>{{ firstEmployeeDisplayName }} is connected</span>
              </p>
              <p class="journey-hint" *ngIf="!firstDayReviewReady && firstDayEvidenceRefreshFailed">
                Couldn’t refresh signals just now.
                <button
                  type="button"
                  class="journey-link"
                  [disabled]="isRefreshingFirstDayEvidence"
                  (click)="refreshFirstDaySignals()">
                  {{ isRefreshingFirstDayEvidence ? 'Refreshing…' : 'Refresh signals' }}
                </button>
              </p>
              <div class="journey-actions journey-connected-actions">
                <button
                  type="button"
                  class="journey-btn-primary"
                  *ngIf="firstDayReviewReady; else doneForNow"
                  (click)="finishFirstEmployeeAfterHeartbeat(true)">
                  Review first signals
                  <mat-icon aria-hidden="true">arrow_forward</mat-icon>
                </button>
                <ng-template #doneForNow>
                  <button
                    type="button"
                    class="journey-btn-primary"
                    (click)="finishFirstEmployeeAfterHeartbeat(false)">
                    Done for now
                    <mat-icon aria-hidden="true">arrow_forward</mat-icon>
                  </button>
                </ng-template>
              </div>
            </div>
            <p class="journey-hint" *ngIf="!firstDayReviewReady">
              SuperSee will keep collecting on their computer.
            </p>
          </ng-container>
        </ng-container>
      </div>

      <!-- B4 First day -->
      <div class="step-content journey-stage journey-flow journey-review" *ngIf="currentStepId === 'first_day_review'">
        <button class="journey-back" (click)="goBack()"><mat-icon>arrow_back</mat-icon> Back</button>
        <div class="journey-hero journey-hero-narrow">
          <p class="journey-kicker">Review</p>
          <h1 class="journey-display">{{ guideCopy.reviewLead }}</h1>
          <p class="journey-companion">{{ journeyCompanionLine }}</p>
          <p class="journey-hint">{{ guideCopy.reviewCoaching }}</p>
          <div class="journey-actions" *ngIf="firstDayReviewReady">
            <button type="button" class="journey-btn-primary" (click)="openFirstUsefulWorkday()">
              {{ guideCopy.reviewOpenCta }} <mat-icon>arrow_forward</mat-icon>
            </button>
          </div>
        </div>
        <div class="journey-wait is-waiting" *ngIf="!firstDayReviewReady">
          <mat-icon class="spinning">sync</mat-icon>
          <div>
            <strong>Waiting for live connection and evidence</strong>
            <p>{{ setupMethod === 'invite' ? guideCopy.firstDayWaitingCopy : 'Keep / Scale unlock when signals below are real — not placeholders.' }}</p>
          </div>
        </div>
        <div class="journey-daily-insights" [class.is-ready]="dailyInsightsEligible">
          <mat-icon aria-hidden="true">mail</mat-icon>
          <div>
            <strong>Daily Insights email</strong>
            <p>{{ dailyInsightsEligible ? guideCopy.dailyInsightsReady : guideCopy.dailyInsightsPending }}</p>
            <p class="journey-hint" *ngIf="firstDayReviewReady && !dailyInsightsEligible">
              Early review can unlock before Daily Insights. Email waits for a fuller day, shift/day end, and a configured recipient.
            </p>
          </div>
        </div>
        <div class="journey-review-grid">
          <div class="journey-review-metric">
            <span>Tracked time</span>
            <strong>{{ firstDaySignals.trackedMinutes != null ? (firstDaySignals.trackedMinutes + ' min') : 'Collecting…' }}</strong>
          </div>
          <div class="journey-review-metric">
            <span>Active</span>
            <strong>{{ firstDaySignals.activeMinutes != null ? (firstDaySignals.activeMinutes + ' min') : 'Collecting…' }}</strong>
          </div>
          <div class="journey-review-metric">
            <span>Idle</span>
            <strong>{{ firstDaySignals.idleMinutes != null ? (firstDaySignals.idleMinutes + ' min') : 'Collecting…' }}</strong>
          </div>
          <div class="journey-review-metric">
            <span>Apps</span>
            <strong>{{ firstDaySignals.appsCount != null ? firstDaySignals.appsCount : 'Collecting…' }}</strong>
          </div>
          <div class="journey-review-metric">
            <span>Sites</span>
            <strong>{{ firstDaySignals.sitesCount != null ? firstDaySignals.sitesCount : 'Collecting…' }}</strong>
          </div>
          <div class="journey-review-metric">
            <span>Screenshots</span>
            <strong>{{ firstDaySignals.screenshotsCount != null ? firstDaySignals.screenshotsCount : 'Collecting…' }}</strong>
          </div>
        </div>
        <p class="journey-hint">{{ firstDaySignals.gapsNote }}</p>
        <div class="journey-actions journey-decision-panel" *ngIf="firstDayReviewReady; else firstDayWaitingActions">
          <p class="journey-next-rec">Decision</p>
          <button class="journey-btn-primary" (click)="finishFirstDayReview('keep')">
            Looks good — continue with this employee <mat-icon>check</mat-icon>
          </button>
          <button class="journey-btn-quiet" (click)="finishFirstDayReview('adjust')">Adjust setup</button>
          <button class="journey-btn-quiet" (click)="finishFirstDayReview('scale')">Add another employee</button>
          <button class="journey-btn-quiet" (click)="continueLaterFromJourney()">Collect more data</button>
        </div>
        <ng-template #firstDayWaitingActions>
          <div class="journey-actions">
            <button class="journey-btn-quiet" (click)="refreshFirstDaySignals()">Refresh signals</button>
            <button class="journey-btn-quiet" [disabled]="!isAgentOnline || isRequestingScreenshot" (click)="requestScreenshot()">
              <mat-icon [class.spinning]="isRequestingScreenshot">{{ isRequestingScreenshot ? 'sync' : 'photo_camera' }}</mat-icon>
              Capture screenshot
            </button>
            <button class="journey-btn-quiet" (click)="continueLaterFromJourney()">Continue later</button>
          </div>
          <p class="journey-hint">No dominant CTA while waiting — Keep / Scale stay locked until early-review signals are real.</p>
        </ng-template>
        <div class="journey-objection-links" style="margin-top: 1rem;">
          <button type="button" class="journey-link" (click)="showFirstDayObjections = !showFirstDayObjections">
            {{ showFirstDayObjections ? 'Hide fair-review notes' : 'Reading a first day fairly' }}
          </button>
        </div>
        <div class="journey-drawer" *ngIf="showFirstDayObjections">
          <div class="journey-objection" *ngFor="let item of guideCopy.objections.firstDayReview">
            <strong>{{ item.title }}</strong>
            <p>{{ item.body }}</p>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- ===================== CLASSIC CHECKLIST ===================== -->
    <ng-container *ngIf="!journeyEnabled">
    <!-- Step 1: Mode Selection -->
    <div class="step-content" *ngIf="currentStepId === 'mode_selection'">
      <div class="step-header">
        <p class="step-tagline">Let's set up your tracking preferences</p>
        <h2>How would you like SuperSee to operate on employee devices?</h2>
        <p>Select the tracking mode that aligns with your company policy. You can switch between modes anytime.</p>
      </div>

      <div class="tip-callout">
        <span class="tip-icon">&#11088;</span>
        <span><strong>Tip:</strong> For the fastest setup and quick testing, start with <strong>Employee
            Controlled</strong>. You can change this anytime in Settings.</span>
      </div>

      <div class="mode-cards">
        <div *ngFor="let mode of modes" class="mode-card"
          [class.selected]="!mode.locked && selectedMode === mode.id"
          [class.mode-card--locked]="mode.locked"
          (click)="selectMode(mode.id)">
          <div class="mode-icon" [class.selected]="!mode.locked && selectedMode === mode.id">
            <mat-icon>{{ mode.icon }}</mat-icon>
          </div>
          <h3>
            {{ mode.title }}
            <mat-icon *ngIf="mode.locked" class="mode-lock" aria-hidden="true">lock</mat-icon>
          </h3>
          <p>{{ mode.description }}</p>
          <ul class="mode-features">
            <li *ngFor="let feature of mode.features">
              <mat-icon class="check-icon">check</mat-icon>
              {{ feature }}
            </li>
          </ul>
          <span class="recommended-badge" *ngIf="mode.id === 'employee_controlled'">&#10004; Recommended for quick
            testing</span>
        </div>
      </div>

      <div class="step-actions">
        <button class="btn-primary btn-continue" [disabled]="!selectedMode || isLoading"
          (click)="confirmModeSelection()">
          <span *ngIf="!isLoading">
            Continue
            <mat-icon>arrow_forward</mat-icon>
          </span>
          <span *ngIf="isLoading">
            <mat-icon class="loading-spinner">refresh</mat-icon>
            Saving...
          </span>
        </button>
      </div>
    </div>

    <!-- Step 2: Create Employee -->
    <div class="step-content" *ngIf="currentStepId === 'create_employee'">
      <button class="back-button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon> Back
      </button>
      <div class="step-header">
        <h2>Add Your First Employee</h2>
        <p>Add employee details and select their device to generate the installer.</p>
      </div>

      <div class="form-card">
        <h3>Employee Details</h3>
        <p class="form-subtitle">Enter the employee information below</p>

        <div class="form-row">
          <div class="form-group">
            <label>Full Name *</label>
            <input type="text" [(ngModel)]="employeeForm.name" placeholder="John Doe" />
          </div>

          <div class="form-group">
            <label>Email Address *</label>
            <input type="email" [(ngModel)]="employeeForm.email" placeholder="john@company.com" />
          </div>
        </div>

        <div class="form-group">
          <label>Password</label>
          <div class="password-field">
            <div class="password-input-row">
              <div class="password-input-wrapper">
                <input [type]="showPassword ? 'text' : 'password'" [(ngModel)]="employeeForm.password"
                  (ngModelChange)="onPasswordChange($event)" (blur)="passwordControl.markAsTouched()"
                  placeholder="Leave blank for auto-generated" />
                <button type="button" class="icon-btn" (click)="togglePasswordVisibility()">
                  <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
              </div>
              <button type="button" class="btn-generate" (click)="generateAndSetPassword()">
                <mat-icon>autorenew</mat-icon>
                Generate
              </button>
            </div>
            <p class="field-hint" *ngIf="!employeeForm.password">Auto-generated secure password (8+ chars, uppercase,
              lowercase, number, special character).</p>
            <p class="field-error"
              *ngIf="passwordControl.invalid && passwordControl.touched && passwordControl.errors?.password">
              {{ passwordControl.errors?.password }}
            </p>
          </div>
        </div>

        <div class="form-group">
          <label>Select the employee’s device *</label>
          <div class="os-options">
            <div *ngFor="let os of osOptions" class="os-option" [class.selected]="employeeForm.os === os.id"
              (click)="selectOS(os.id)">
              <mat-icon>{{ os.icon }}</mat-icon>
              <span>{{ os.label }}</span>
            </div>
          </div>
          <p class="field-hint">After creation, you'll download the installer and install it on the employee's device.
          </p>
        </div>

        <div class="form-actions">
          <button class="btn-primary btn-full" [disabled]="!isEmployeeFormValid() || isLoading || !!createdEmployee"
            (click)="createEmployee()">
            <mat-icon [class.spinning]="isLoading">{{ isLoading ? 'sync' : 'person_add' }}</mat-icon>
            {{ isLoading ? 'Creating Employee...' : 'Add Employee & Download Installer' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Step 3: Install Agent -->
    <div class="step-content" *ngIf="currentStepId === 'install_agent'">
      <button class="back-button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon> Back
      </button>
      <div class="step-header">
        <h2>Install SuperSee Agent</h2>
        <p>Download and install the agent on the employee's device. You can try it on your own system first.</p>
      </div>

      <!-- Employee Info Card -->
      <div class="form-card" *ngIf="createdEmployee">
        <div class="employee-info-bar">
          <mat-icon class="employee-avatar">person</mat-icon>
          <div class="employee-info-text">
            <strong>{{ createdEmployee.first_name }} {{ createdEmployee.last_name }}</strong>
            <div *ngIf="createdEmployee.version_type !== 'silent'" class="employee-credentials">
              <span class="copy-item" (click)="copyToClipboard(createdEmployee.email, 'email')">
                {{ createdEmployee.email }}
                <mat-icon class="copy-icon">{{ copiedField === 'email' ? 'check' : 'content_copy' }}</mat-icon>
              </span>
              <span class="copy-divider">|</span>
              <span class="copy-item" (click)="copyToClipboard(createdEmployeePassword, 'password')">
                {{ createdEmployeePassword }}
                <mat-icon class="copy-icon">{{ copiedField === 'password' ? 'check' : 'content_copy' }}</mat-icon>
              </span>
            </div>
          </div>
          <div class="agent-status-badge" [class.online]="isAgentOnline"
            [class.checking]="isCheckingStatus && !isAgentOnline">
            <mat-icon *ngIf="isAgentOnline">check_circle</mat-icon>
            <mat-icon *ngIf="isCheckingStatus && !isAgentOnline" class="spinning">sync</mat-icon>
            <mat-icon *ngIf="!isCheckingStatus && !isAgentOnline">wifi_find</mat-icon>
            <span *ngIf="isAgentOnline">Online</span>
            <span *ngIf="isCheckingStatus && !isAgentOnline">Checking...</span>
            <span *ngIf="!isCheckingStatus && !isAgentOnline">Offline</span>
          </div>
        </div>

        <div class="installer-notice">
          <span class="material-symbols-outlined"
            style="color:#43a047;margin-right:7px;font-size:22px;">cloud_download</span>
          <span>The SuperSee installer will be <b>downloaded</b> when you click the button below. Please <b>follow the
              steps to complete setup</b> on the employee's system.</span>
        </div>
      </div>

      <!-- Installation Instructions based on OS + Mode -->
      <div class="form-card">
        <div class="install-title">{{ getCreatedEmployeeOSLabel() }} – {{ getInstallerTypeLabel() }}</div>

        <!-- Download Button -->
        <div class="download-button-container" style="margin: 16px 0;">
          <button class="btn-primary btn-download" [disabled]="isDownloading" (click)="downloadAgent()">
            <mat-icon *ngIf="!isDownloaded">cloud_download</mat-icon>
            <mat-icon *ngIf="isDownloaded" class="success">check_circle</mat-icon>
            {{ isDownloaded ? 'Downloaded — Click to Re-download' : 'Download Agent Installer' }}
          </button>
        </div>

        <!-- Windows Instructions -->
        <ng-container *ngIf="getCreatedEmployeeOS() === 'windows'">
          <p class="installer-av-tip" role="note">{{ guideCopy.installAntivirusTip }}</p>
          <!-- Hidden / Silent -->
          <ol *ngIf="createdEmployee?.version_type === 'silent' && isWindowsRustInstall" class="install-instructions">
            <li>📁 Share the downloaded setup file to the employee's system or try it on your device.</li>
            <li>📦 Unzip the whole folder. Do not run the MSI from inside the zip.</li>
            <li>🖱️ Double-click the Settings <b>.msi</b> (keep the secrets file next to it). When Windows asks to allow the app, choose Yes.</li>
            <li>✅ Settings runs in the background without a day-to-day widget — still introduce SuperSee openly.</li>
            <li>🗑️ Delete the installer files from the system.</li>
            <li>🔁 Restart the system (mandatory).</li>
          </ol>
          <ol *ngIf="createdEmployee?.version_type === 'silent' && !isWindowsRustInstall" class="install-instructions">
            <li>📁 Share the downloaded <b>.bat</b> file to the employee's system or try it on your device.</li>
            <li>🖱️ Right-click → Run as Administrator.</li>
            <li>⚠️ If prompted, click More Info → Run Anyway, then click Yes on both popups.</li>
            <li>⏳ Let the terminal complete all 8 steps — it will close automatically.</li>
            <li>✅ SuperSee runs in the background without a day-to-day widget — still introduce SuperSee openly.</li>
            <li>🗑️ Delete the installer file from the system.</li>
            <li>🔁 Restart the system (mandatory).</li>
          </ol>
          <!-- Employee Controlled / General -->
          <ol *ngIf="createdEmployee?.version_type === 'general' && isWindowsRustInstall" class="install-instructions">
            <li>📁 Share the downloaded setup file to the employee's system or try it on your device.</li>
            <li>🖱️ Double-click the .msi. When Windows asks to allow the app, choose Yes.</li>
            <li>🔐 Employee logs in using the provided credentials.</li>
            <li>🔁 Restart the system (mandatory).</li>
          </ol>
          <ol *ngIf="createdEmployee?.version_type === 'general' && !isWindowsRustInstall" class="install-instructions">
            <li>📁 Share the downloaded <b>.bat</b> file to the employee's system or try it on your device.</li>
            <li>🖱️ Right-click → Run as Administrator.</li>
            <li>⚠️ If prompted, click More Info → Run Anyway, then click Yes on both popups.</li>
            <li>⏳ Let the terminal complete all 8 steps — it will close automatically.</li>
            <li>🔐 Employee logs in using the provided credentials.</li>
            <li>🔁 Restart the system (mandatory).</li>
          </ol>
          <!-- Admin Controlled / Restricted -->
          <ol *ngIf="createdEmployee?.version_type === 'restricted' && isWindowsRustInstall" class="install-instructions">
            <li>📁 Share the downloaded setup file to the employee's system or try it on your device.</li>
            <li>📦 Unzip the whole folder. Do not run the MSI from inside the zip.</li>
            <li>🖱️ Double-click the SuperSee <b>.msi</b> (keep the secrets file next to it). When Windows asks to allow the app, choose Yes.</li>
            <li>🔐 Employee logs in using the provided credentials (one-time only).</li>
            <li>⚠️ Employee cannot Start/Stop timer or Sign out — tracking auto-starts.</li>
            <li>📊 Employee can only view their History and widget.</li>
            <li>🔁 Restart the system (mandatory).</li>
          </ol>
          <ol *ngIf="createdEmployee?.version_type === 'restricted' && !isWindowsRustInstall" class="install-instructions">
            <li>📁 Share the downloaded <b>.bat</b> file to the employee's system or try it on your device.</li>
            <li>🖱️ Right-click → Run as Administrator.</li>
            <li>⚠️ If prompted, click More Info → Run Anyway, then click Yes on both popups.</li>
            <li>⏳ Let the terminal complete all 8 steps — it will close automatically.</li>
            <li>🔐 Employee logs in using the provided credentials (one-time only).</li>
            <li>⚠️ Employee cannot Start/Stop timer or Sign out — tracking auto-starts.</li>
            <li>📊 Employee can only view their History and widget.</li>
            <li>🔁 Restart the system (mandatory).</li>
          </ol>
        </ng-container>

        <!-- macOS Instructions -->
        <ng-container *ngIf="getCreatedEmployeeOS() === 'mac'">
          <ol *ngIf="createdEmployee?.version_type === 'silent'" class="install-instructions">
            <li>📁 Share the downloaded <b>.command</b> file to the employee's system.</li>
            <li>🖱️ Right-click → Get Info → Set Read & Write for (Me, staff, everyone).</li>
            <li>💻 Open Terminal, navigate to the file location and run:
              <pre class="code-block"><code>sudo chmod +x [filename]<br>./[filename]</code></pre>
            </li>
            <li>⚙️ After install, enable SuperSee under Accessibility and Screen & Audio Recording in System Settings.
            </li>
            <li>✅ SuperSee will auto-start in the background — no day-to-day widget; still introduce SuperSee openly.</li>
            <li>🗑️ Delete the installer file from the employee's system.</li>
            <li>🔁 Restart the system (mandatory).</li>
          </ol>
          <ol *ngIf="createdEmployee?.version_type === 'general'" class="install-instructions">
            <li>📁 Share the downloaded <b>.dmg</b> file to the employee's system.</li>
            <li>🖱️ Open the .dmg file → Drag SuperSee into Applications.</li>
            <li>🖱️ Right-click SuperSee → Get Info → Set Read & Write for (Me, staff, everyone).</li>
            <li>⚙️ Go to System Settings → Privacy & Security → Allow SuperSee under Accessibility and Screen & Audio
              Recording.</li>
            <li>🚀 Launch SuperSee and log in with credentials.</li>
            <li>🔁 Restart the system (mandatory).</li>
          </ol>
          <ol *ngIf="createdEmployee?.version_type === 'restricted'" class="install-instructions">
            <li>📁 Share the downloaded <b>.dmg</b> file to the employee's system.</li>
            <li>🖱️ Open the .dmg file → Drag SuperSee into Applications.</li>
            <li>🖱️ Right-click SuperSee → Get Info → Set Read & Write for (Me, staff, everyone).</li>
            <li>⚙️ Go to System Settings → Privacy & Security → Allow SuperSee under Accessibility and Screen & Audio
              Recording.</li>
            <li>🚀 Launch SuperSee and log in with credentials (one-time only).</li>
            <li>⚠️ Employee cannot Start/Stop timer or Sign out — tracking auto-starts.</li>
            <li>📊 Employee can only view their History and widget.</li>
            <li>🔁 Restart the system (mandatory).</li>
          </ol>
        </ng-container>

        <!-- Linux Instructions -->
        <ng-container *ngIf="getCreatedEmployeeOS() === 'linux'">
          <ol *ngIf="createdEmployee?.version_type === 'silent'" class="install-instructions">
            <li>📁 Share the downloaded <b>.sh</b> file to the employee's system.</li>
            <li>🖱️ Right-click → Properties → Permissions → Set Read & Write and check "Allow executing file as
              program".</li>
            <li>🖱️ Right-click the .sh file → Run as Program.</li>
            <li>🔑 If prompted, enter the system password to allow installation.</li>
            <li>✅ SuperSee agent will install and auto-start in the background — still introduce SuperSee openly; not secret monitoring.</li>
            <li>🗑️ Delete the installer file from the employee's system.</li>
            <li>🔁 Restart the system (mandatory).</li>
          </ol>
          <ol *ngIf="createdEmployee?.version_type === 'general'" class="install-instructions">
            <li>📁 Share the downloaded <b>.deb</b> file to the employee's system.</li>
            <li>🖱️ Right-click → Properties → Permissions → Set Read & Write and check "Allow executing file as
              program".</li>
            <li>🧩 Right-click the .deb file → Open With → Software Install, then click Install.</li>
            <li>🚀 Once installed, open SuperSee from the Applications menu.</li>
            <li>🔐 Log in using the credentials provided by the manager.</li>
            <li>🔁 Restart the system (mandatory).</li>
          </ol>
          <ol *ngIf="createdEmployee?.version_type === 'restricted'" class="install-instructions">
            <li>📁 Share the downloaded <b>.deb</b> file to the employee's system.</li>
            <li>🖱️ Right-click → Properties → Permissions → Set Read & Write and check "Allow executing file as
              program".</li>
            <li>🧩 Right-click the .deb file → Open With → Software Install, then click Install.</li>
            <li>🚀 Once installed, open SuperSee from the Applications menu.</li>
            <li>🔐 Log in using the credentials provided by the manager (one-time only).</li>
            <li>⚠️ Employee cannot Start/Stop timer or Sign out — tracking auto-starts.</li>
            <li>📊 Employee can only view their History and widget.</li>
            <li>🔁 Restart the system (mandatory).</li>
          </ol>
        </ng-container>
      </div>

      <!-- Browser Notice -->
      <div class="alert-box warning" style="margin-top: 16px;">
        <mat-icon>warning</mat-icon>
        <div>
          <strong>Browser Notice:</strong> You may see "This file isn't commonly downloaded."
          <br>It's safe to continue — the file is securely generated by SuperSee.
        </div>
      </div>

      <!-- Agent Status Inline -->
      <div class="agent-status-inline" *ngIf="isCheckingStatus && !isAgentOnline">
        <mat-icon class="spinning">sync</mat-icon>
        <span>Waiting for agent to come online... Checking automatically.</span>
        <button class="btn-small btn-outline" (click)="stopPolling()">Stop</button>
      </div>
      <div class="agent-status-inline success" *ngIf="isAgentOnline">
        <mat-icon class="success">check_circle</mat-icon>
        <span><strong>Agent is online!</strong> Ready to capture screenshots and activity.</span>
      </div>

      <div class="step-actions">
        <button class="btn-primary btn-continue" [disabled]="!isAgentOnline" (click)="goToStep('request_screenshot')">
          Continue
          <mat-icon>arrow_forward</mat-icon>
        </button>

        <button class="btn-outline btn-continue" [disabled]="isCheckingStatus" (click)="checkAgentStatus()">
          <mat-icon [class.spinning]="isCheckingStatus">sync</mat-icon>
          {{ isCheckingStatus ? 'Checking...' : 'Check Again' }}
        </button>
      </div>
    </div>

    <!-- Step 4: Request Screenshot -->
    <div class="step-content" *ngIf="currentStepId === 'request_screenshot'">
      <button class="back-button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon> Back
      </button>
      <div class="step-header">
        <h2>Request Your First Screenshot</h2>
        <p>Test the screenshot feature to ensure everything is working correctly.</p>
      </div>

      <div class="form-card centered">
        <div class="screenshot-box" [class.success]="isScreenshotCaptured">
          <!-- Failed state: after 2 unsuccessful attempts -->
          <div *ngIf="screenshotFailed && !isScreenshotCaptured" class="screenshot-failed">
            <div class="icon-circle error">
              <mat-icon>error_outline</mat-icon>
            </div>
            <strong>Screenshot Capture Failed</strong>
            <span>We couldn't capture a screenshot after multiple attempts. Please contact support for
              assistance.</span>
            <div class="failed-actions">
              <button class="btn-primary" (click)="contactScreenshotSupport()">
                <mat-icon>support_agent</mat-icon>
                Contact Support
              </button>
              <button class="btn-outline" (click)="finishOnboarding()">
                <mat-icon>dashboard</mat-icon>
                Go to Dashboard
              </button>
            </div>
          </div>

          <!-- Normal state -->
          <div *ngIf="!isScreenshotCaptured && !screenshotFailed" class="screenshot-placeholder">
            <div class="icon-circle">
              <mat-icon>photo_camera</mat-icon>
            </div>
            <strong>Ready to Capture</strong>
            <span>Click the button below to request a screenshot</span>
            <button class="btn-primary" [disabled]="isRequestingScreenshot || isResolvingScreenshotTarget"
              (click)="requestScreenshot()">
              <mat-icon [class.spinning]="isRequestingScreenshot || isResolvingScreenshotTarget">{{
                (isRequestingScreenshot || isResolvingScreenshotTarget) ? 'sync' : 'photo_camera' }}</mat-icon>
              {{ isResolvingScreenshotTarget ? 'Preparing...' : (isRequestingScreenshot ? 'Requesting...' : 'Request
              Screenshot') }}
            </button>
            <span class="attempt-count" *ngIf="screenshotRequestCount > 0">Attempt {{ screenshotRequestCount }} of
              2</span>
          </div>

          <div *ngIf="isScreenshotCaptured" class="screenshot-success">
            <div class="icon-circle success">
              <mat-icon>check_circle</mat-icon>
            </div>
            <strong>Screenshot Captured!</strong>
            <span>The screenshot has been saved and is ready to view</span>
            <button class="btn-outline" (click)="viewScreenshots()">
              <mat-icon>open_in_new</mat-icon>
              View Screenshots
            </button>

            <div class="completion-inline">
              <div class="completion-icon">
                <mat-icon>celebration</mat-icon>
              </div>
              <h3>Onboarding Complete!</h3>
              <p>You've successfully set up SuperSee. You're ready to start monitoring productivity.</p>
              <p class="completion-note">Application logs and timesheets will appear within 5-10 minutes.</p>
              <button class="btn-primary" (click)="finishOnboarding()">
                <mat-icon>dashboard</mat-icon>
                Go to Dashboard
              </button>
            </div>
          </div>
        </div>

        <p class="note"><strong>Note:</strong> Screenshots are captured instantly and stored securely. You can configure
          automatic screenshot intervals in Settings.</p>
        <!-- Linux Wayland instructions -->
        <div class="linux-wayland-notice" *ngIf="isLinuxEmployee() && !isScreenshotCaptured">
          <div class="notice-header">
            <mat-icon>info</mat-icon>
            <strong>Ubuntu/Linux Setup Required</strong>
          </div>
          <p>If you're using an Ubuntu environment, you may need to ensure that the Wayland display server protocol is
            correctly set up:</p>
          <ol class="wayland-steps">
            <li>Open the terminal and enter: <code>sudo nano /etc/gdm3/custom.conf</code></li>
            <li>Look for the line: <code>#WaylandEnable=false</code></li>
            <li>Ensure it is set to <code>false</code>. If not, remove the <code>#</code> at the start of the line.</li>
            <li>Save the file by pressing <strong>Ctrl + X</strong>, then <strong>Y</strong>, and finally
              <strong>Enter</strong>.</li>
            <li>Restart the system for changes to take effect.</li>
          </ol>
        </div>

      </div>
    </div>
    </ng-container>
  </main>

  <!-- Footer: classic checklist only — journey keeps leave/skip inside each stage -->
  <footer class="onboarding-footer"
    *ngIf="!journeyEnabled && !(currentStepId === 'request_screenshot' && isScreenshotCaptured)">
    <button class="btn-text" (click)="skipOnboarding()">
      Skip for now
    </button>
  </footer>
</div>